class ClaimsObserver {
  constructor() {
    this.observers = [];
  }

  subscribe(observer) {
    this.observers.push(observer);
  }

  unsubscribe(observer) {
    let index = this.observers.indexOf(observer);
    if (index > -1) {
      this.observers.slice(index, 1);
    }
  }

  broadcast(data) {
    this.observers.forEach((subscriber) => subscriber(data));
  }
}

const claimsObserver = new ClaimsObserver();

export default claimsObserver;
